import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';


export default ({ showReleaseNotes }) => {

    const [isOpen, setIsOpen] = useState(false);

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
            <DropdownToggle caret style={{ backgroundColor: "transparent", border: "none", boxShadow: "none", float: "right" }}>
                Help
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem onClick={showReleaseNotes}>
                    Release notes
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};
